import { createGetEndpoint } from '@sonar-software/sonar-http';
import { UserSalesforcePreferences } from '@types';

export type GetUserSalesforcePreferencesRequest = {
	userId: number;
};

export const getUserSalesforcePreferences = createGetEndpoint<
	GetUserSalesforcePreferencesRequest,
	UserSalesforcePreferences
>((request) => `/api/v2/user/${request.userId}/salesforce-preferences`);
